export enum LOGIN_CONTEXT {
  LOGGING_IN = 'LOGGING_IN',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFY_CODE = 'VERIFY_CODE',
  SUCCESS_RESET = 'SUCCESS_RESET',
}

export enum LOGIN_TYPE {
  EMAIL = 'email',
  PHONE = 'phoneNumber',
  GOVERNMENTAL_ID = 'governmentalId',
}

export enum GHOST_DIALOG_TYPE {
  PLACE_BET = 'PLACE_BET',
  WATCH_STREAM_LOG_IN = 'WATCH_STREAM_LOG_IN',
  WATCH_STREAM_MAKE_FIRST_DEPOSIT = 'WATCH_STREAM_MAKE_FIRST_DEPOSIT',
}
